import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
import { SIGNATORY_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const MAIN_SIGNATORY_READ = gql `
    ${SIGNATORY_FIELDS}
    query readMainSignatory($dossierId: Long) {
      read_main_signatory(dossierId: $dossierId) {
        ...SignatoryFields
      }
    }
  `;
export const useMainSignatoryReadLazyQuery = (options) => {
    return useLazyQuery(MAIN_SIGNATORY_READ, Object.assign({ errorPolicy: 'all' }, options));
};
export const useMainSignatoryReadQuery = (options) => {
    return useQuery(MAIN_SIGNATORY_READ, Object.assign({ errorPolicy: 'all' }, options));
};
export const useMainSignatoryReadQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: MAIN_SIGNATORY_READ, variables }));
};
